String.prototype.isEmpty = function() {
    return (this.length === 0 || this.trim().length === 0);
};

window.init_account_form = function() {
    window.form_type = 'account'
    window.liveValidation = false
    window.validate_fields = [
        'first_name', 'last_name', 'email', 'login_name', 'password', 'password_confirm',
        'os_user', 'os_pass', 'last_course_date', 'last_course_location', 'last_course_teachers']

    refresh_verification_view()
    $('#forgot-verification-cb').change(function() {
        refresh_verification_view()
    })

    $('.profile-form').submit(function(event) {
        if ($('input[name=edit_option]').val() === 'delete') {
            return true
        }
        return validate_form()
    })

    $('#create_profile').click(function() {
        submit_profile_form()
    })

    $('#accept_policy').click(function() {
        $('.policy-acknowledgement').modal('hide');
        $('#policy_ack_field').val(Date.now())
        $('.profile-form').submit()
    })

    $('#reject_policy, .modal-header .close').click(function() {
        $('.policy-acknowledgement').modal('hide');
    })

    $('#old_student_checkbox').change(function () {
        refresh_verification_view()
    })

    window.validate_fields.forEach(function(field) {
        $('#' + field).on("change paste keyup", function() {
            if (window.liveValidation === true) {
                var item = $(this).attr('id')
                is_field_valid(item)
                if (item === 'os_user') is_field_valid('os_pass')
                if (item === 'os_pass') is_field_valid('os_user')
            }
        })
    });

    detect_form_edit()
    process_input_errors()
}

window.init_create_profile_form = function() {
    window.form_type = 'profile'
    window.edit_mode = false
    window.liveValidation = false
    window.validate_fields = ['email', 'login_name', 'password', 'password_confirm', 'os_user', 'os_pass']
    refresh_verification_view()
    window.validate_fields.forEach(function(field) {
        $('#' + field).on("change paste keyup", function() {
            if (window.liveValidation === true) {
                var item = $(this).attr('id')
                is_field_valid(item)
                if (item === 'os_user') is_field_valid('os_pass')
                if (item === 'os_pass') is_field_valid('os_user')
            }
        });
    });
    $('#create_profile_cb').change(function() {
        if ($(this).prop('checked')) {
            $('#account_form').show()
            $('#create_profile_btn').show()
        } else {
            $('#account_form').hide()
            $('#create_profile_btn').hide()
        }
    })
    $('#create_profile_btn').click(function () {
        submit_profile_form()
    })
    $('#old_student_checkbox').change(function () {
        refresh_verification_view()
    })
    process_input_errors()
}

window.init_contact_form = function() {
    window.form_type = 'contact'
    window.liveValidation = false
    window.validate_fields = []
    $('#home_country_id').change(function () {
        load_state_provinces($('#home_country_id').val())
    })
    $('.profile-form').submit(function(event) {
        return validate_form()
    })
    detect_form_edit()
    process_input_errors()
}

window.init_personal_form = function() {
    function marital_status_refresh() {
        if ($('#marital_status').val() === 'Married') {
            $('#spouse_name_field').show()
            $('#spouse_is_meditator_field').show()
        } else {
            $('#spouse_name_field').hide()
            $('#spouse_is_meditator_field').hide()
        }
    }

    function hide_altname_fields_downto(index, animate) {
        for (var n = 5; n > index; n--) {
            var current = $('#alternate_name' + n + '_field')
            var previous = $('#alternate_name' + (n-1) + '_field')
            if ($('input', current).val().length === 0) {
                if ($('input', previous).val().length === 0) {
                    current.hide(animate ? 400 : 0)
                } else {
                    break
                }
            } else {
                break
            }
        }
    }

    window.form_type = 'personal'
    window.liveValidation = false
    window.validate_fields = ['date_of_birth']
    $('#home_country_id').change(function () {
        load_state_provinces($('#home_country_id').val())
    })
    $('.profile-form').submit(function(event) {
        return validate_form()
    })
    $('.select-lang-prof').on("change", function() {
        $('#lang_prof_modified').val('true')
        if (window.liveValidation === true) validate_all_lang_profs(true, false)
    })
    $('#profile_image').on('change', function() {
        $('#profile_image_field .input-image').css('display', 'none')
    })
    for (var n = 1; n <= 5; n++) {
        $('#alternate_name' + n + '_field').on("change paste keyup", function() {
            var index = parseInt($(this).attr('id').replace(/\D/g,'')) + 1
            var input = $('input', this).val()
            if (index <= 5) {
                var next = $('#alternate_name' + index + '_field')
                if (input.length > 0) {
                    if (!next.is(":visible")) next.show(400)
                } else {
                    hide_altname_fields_downto(index-1, true)
                }
            }
        })
    }
    $('#marital_status').on('change', function() {
        marital_status_refresh()
    })
    detect_form_edit()
    process_input_errors()
    hide_altname_fields_downto(1, false)
    marital_status_refresh()
}

window.init_course_history_form = function() {
    window.form_type = 'courses'
    $('input[inputmode=numeric]').on("change paste keyup", function() {
        var val = $(this).val().replace(/[^0-9]/g,'');
        $(this).val(val)
    })
    detect_form_edit()
}

// DO NOT rename or change this function, it is being used by the iOS mobile app
window.submit_profile_form = function() {
    if (window.form_type === 'account') {
        if (validate_form() === true) {
            if ($('.policy-acknowledgement').length > 0) {
                var ack_date = $('#policy_ack_field').val()
                if (ack_date !== '' && Date.now() - parseInt(ack_date) < 60*60*24*30*11*1000) {
                    $('.profile-form').submit();
                } else {
                    $('.policy-acknowledgement').modal('show');
                }
            } else {
                $('.profile-form').submit();
            }
        } else {
            window.liveValidation = true;
        }
        return;
    }
    else if (window.form_type === 'profile') {
        if (validate_form() === true) {
            $('.main-container form input[name=exit_action]').val('create_profile')
            $('.main-container form').submit()
        } else {
            window.liveValidation = true
        }
        return
    }
    else if (window.form_type === 'courses' || window.form_type === 'change_password') {
        if (validate_form() === true) {
            $('.profile-form').submit()
        } else {
            window.liveValidation = true
        }
        return
    }
    else {
        window.liveValidation = true
    }
    $('.profile-form').submit()
}

window.init_settings = function() {
    window.form_type = 'settings'
    detect_form_edit()
}

window.init_change_password = function() {
    window.form_type = 'change_password'
    window.liveValidation = false
    window.edit_mode = false
    window.validate_fields = ['current_password', 'password', 'password_confirm']
    window.validate_fields.forEach(function(field) {
        $('#' + field).on("change paste keyup", function() {
            if (window.liveValidation === true) {
                is_field_valid($(this).attr('id'))
            }
        })
    });
    process_input_errors()
    detect_form_edit()
}

window.init_phone_field = function(target, script) {
    var input = window.intlTelInput(document.querySelector(target), {
        nationalMode: false,
        utilsScript: script,
        formatOnDisplay: true,
        initialCountry: window.current_country_code !== undefined ? window.current_country_code : "us",
        autoHideDialCode: true,
        customPlaceholder: function(selectedCountryPlaceholder, countryData) {
            var placeholder = ""
            try {
                const dialCode = countryData.dialCode;
                const dialCodeRegex = new RegExp("\\+" + dialCode.slice(0, 1) + "\\s?" + dialCode.slice(1));
                const dialCodePlaceholderMatch = selectedCountryPlaceholder.match(dialCodeRegex);
                const dialCodePlaceholder = dialCodePlaceholderMatch ? dialCodePlaceholderMatch[0] : "+" + dialCode;
                const restOfNumber = selectedCountryPlaceholder.replace(dialCodeRegex, '');
                placeholder = dialCodePlaceholder + restOfNumber.replace(/\d/g, 'x');
            } catch(err) { }
            input._placeholder = placeholder
            return placeholder
            },
    });
    input._placeholder = ''
    input._div = $(target + '_field')
    if (window.tel_inputs === undefined) {
        window.tel_inputs = []
    }
    window.tel_inputs.push(input)
    $(target).on("change paste keyup", function() {
        if(window.liveValidation === true) validate_phone(input)
    });
}

window.process_input_errors = function() {
    var scrolled = false
    if (window.input_errors !== undefined) {
        for (var key in window.input_errors) {
            if (window.input_errors.hasOwnProperty(key)) {
                var div = $('#'+key+'_field')
                div.addClass('has-error')
                $('#' + key).on("change paste keyup", function() {
                    is_field_valid($(this).attr('id'))
                })
                if (scrolled === false && div.length > 0) {
                    scrollToElement(div)
                }
                window.liveValidation = true
            }
        }
    }
}

window.set_tel_country = function(code) {
    if (window.tel_inputs !== undefined) {
        window.tel_inputs.forEach(function(input) {
            if($('input', input._div).val().length === 0) {
                input.setCountry(code)
            }
        });
    }
}

window.load_state_provinces = function(country_id) {
    var path = profile_base_url() + '/contact/country/' + country_id
    var selected_id = -1
    $.getJSON(path, function(data) {
        set_tel_country(data.iso_code)
        var options = '';
        var first_option = '<option value="">' + $('#state_province_id option').html() + '</option>'
        data.provinces.forEach(function(sp) {
            var selected = (sp.id === selected_id) ? 'selected' : ''
            options += '<option value="' + sp.id + '" ' + selected + '>' + sp.description + '</option>'
        });
        $('#state_province_id').empty()
        $('#state_province_id').html(first_option + options)
    }).fail(function () {
        console.log('load data error')
    });
}

window.refresh_verification_view = function() {
    if (is_old_student()) {
        $('#os-verification-form').show()
    } else {
        $('#os-verification-form').hide()
    }
    if (is_forgot_verification()) {
        $('#verification-user-pass-inputs').hide()
        $('#verification-forgot-inputs').show()
    } else {
        $('#verification-user-pass-inputs').show()
        $('#verification-forgot-inputs').hide()
    }
}

window.is_old_student = function() {
    return $('#old_student_checkbox').prop('checked')
}

window.is_forgot_verification = function() {
    return $('input[name=forgot_verification]').prop('checked')
}

window.scrollToElement = function(elm) {
    if (elm.length === 0) {
        console.log('element not found')
        return
    }
    if (window.form_target) {
        window.form_target.scrollTop(window.form_target.scrollTop() + elm.position().top - 15)
    } else {
        var ratio = ($(window).width() <= 768) ? 0.1 : 0.5
        var dist = elm.offset().top - ($(window).height() * ratio)
        $(window).scrollTop(dist)
    }
}

window.scrollToTarget = function(target, containerEl) {
    var isElement = target && target.nodeType === 1,
        isNumber = Object.prototype.toString.call(target) === '[object Number]';

    if (isElement) {
        containerEl.scrollTop = target.offsetTop;
    } else if (isNumber) {
        containerEl.scrollTop = target;
    } else if (target === 'bottom') {
        containerEl.scrollTop = containerEl.scrollHeight - containerEl.offsetHeight;
    } else if (target === 'top') {
        containerEl.scrollTop = 0;
    }
};

window.validate_form = function() {
    var valid = true
    var scrolled = false
    if (window.validate_fields !== undefined) {
        window.validate_fields.forEach(function(field) {
            if (is_field_valid(field) === false) {
                valid = false
                if (!scrolled) {
                    scrollToElement($('#'+field+'_field'))
                    scrolled =  true
                }
            }
        });
    }
    if (window.tel_inputs !== undefined) {
        window.tel_inputs.forEach(function(input) {
            if (!validate_phone(input)) {
                valid = false
                if (!scrolled) {
                    scrollToElement(input._div)
                    scrolled =  true
                }
            }
        });
    }
    if (window.form_type === 'personal') {
        valid = validate_all_lang_profs(valid, scrolled)
    }
    if (window.form_type === 'courses') {
        var tab = $('#selected_tab').val() === '1' ? $('#long-courses') : $('#short-courses')
        $('input[type=number]', tab).each(function() {
            var div = $(this).parent()
            if (/\D/.test($(this).val())) {
                showInvalid(div)
                valid = false
                if (!scrolled) {
                    scrollToElement(div)
                    scrolled =  true
                }
            } else {
                showValid(div)
            }
        })
    }
    return valid
}

window.validate_all_lang_profs = function(valid, scrolled) {
    ['1', '2', '3'].forEach(function(n) {
        valid = validate_lang_proficiency(valid, scrolled, $('#language_' + n), $('#proficiency_' + n))
    });
    valid = validate_lang_proficiency(valid, scrolled, $('#dl_language_1'), $('#dl_proficiency_1'))
    return valid
}

window.validate_lang_proficiency = function(valid, scrolled, lang, prof) {
    var td_lang = lang.parent()
    var td_prof = prof.parent()
    if (!lang.val().isEmpty() && prof.val().isEmpty()) {
        showInvalid(td_prof)
        valid = false
        if (!scrolled) {
            scrollToElement(prof)
            scrolled =  true
        }
    } else {
        showValid(td_prof)
    }
    if (lang.val().isEmpty() && !prof.val().isEmpty()) {
        showInvalid(td_lang)
        valid = false
        if (!scrolled) {
            scrollToElement(lang)
            scrolled =  true
        }
    }
    else {
        showValid(td_lang)
    }
    return valid
}

window.validate_phone = function(input) {
    var number = $('input', input._div).val()
    var hasCountryCode = number.startsWith("+")
    if ((input.isValidNumber() && hasCountryCode) || number.length === 0) {
        showValid(input._div)
        return true
    } else {
        var errorCode = !hasCountryCode ? 6 : input.getValidationError();
        if (window.phone_input_errors) {
            var mesg = window.phone_input_errors[errorCode]
            if (errorCode !== 0 && errorCode !== 4 && input._placeholder !== undefined && input._placeholder !== '') {
                mesg = mesg + ' (' + input._placeholder + ')'
            }
            $('.error-msg', input._div).html(mesg)
        }
        showInvalid(input._div)
        return false
    }
}

window.is_field_valid = function(field, secondary) {
    var message = null
    var invalid = false
    var div = $('#'+field+'_field')
    var input = $('input', div).first()
    if (input.prop('type') === 'radio') {
        input = $('input[type=radio]:checked', div)
        if (input.first().val() === undefined) {
            showInvalid(div)
            return false
        } else {
            showValid(div)
            return true
        }
    }
    if (input.length === 0) input = $('select', div).first()
    var value = input.first().val()
    if (value === undefined) {
        return true
    }
    if (value.length < 1 && field === 'last_name') {
        invalid = true
    }
    if (value.length < 4 && field === 'login_name') {
        invalid = true
    }
    if (field === 'date_of_birth' && !is_date_valid(field, true, false)) {
        invalid = true
    }
    if (field === 'start_date') {
        if (!is_date_valid(field, true, true)) {
            message = get_course_date(field, true).isEmpty() ? PHRASE_REQUIRED : PHRASE_INVALID
            invalid = true;
        }
        else if (selected_date('start_date') > Date.now()) {
            message = PHRASE_FUTURE_DATE_ERROR;
            invalid = true;
        }
    }
    if (field === 'end_date') {
        if (!is_date_valid(field, false, true)) {
            message = PHRASE_INVALID
            invalid = true
        }
        else if (selected_date('end_date') > Date.now()) {
            message = PHRASE_FUTURE_DATE_ERROR;
            invalid = true;
        }
    }
    if (value.length < 1 && field === 'course_location') {
        let loc_id = $('#location_id').find(':selected').val()
        if (loc_id === undefined || loc_id === 'other') {
            invalid = true
        }
    }
    if (value.length < 1 && !field.includes('date') && field !== 'course_location'
        && !field.startsWith('os_') && !field.startsWith('last_') && !field.startsWith('password')) {
        invalid = true
    }
    if (field === 'password' && !is_password_valid(value)) {
        invalid = true
    }
    if (field === 'password_confirm') {
        var password = $('input[name=password]').val()
        if (is_password_valid(password) === true && value !== password) {
            invalid = true
        }
    }
    if (field === 'email' && !is_email_valid(value)) {
        invalid = true
    }
    if ((field.startsWith('os_') || field.startsWith('last_')) && is_old_student()) {
        if (is_forgot_verification()) {
            if(['last_course_date', 'last_course_location', 'last_course_teachers'].includes(field) && value.length < 1) {
                invalid = true
            }
        } else {
            if(['os_user', 'os_pass'].includes(field) && value.length < 1) {
                invalid = true
            }
        }
    }
    if (!invalid && (field === 'start_date' || field === 'end_date')) {
        let other = field === 'start_date' ? 'end_date' : 'start_date'
        if(!is_date_range_valid()) {
            invalid = true
            message = PHRASE_INVALID_DATE_RANGE
        }
        else if(!is_course_duration_valid()) {
            invalid = true
            message = PHRASE_INVALID_DURATION
        }
        else if(is_date_range_overlap() && !get_course_date(field).isEmpty()) {
            invalid = true
            message = PHRASE_DATE_RANGE_OVERLAPS
        }
        else {
            message = PHRASE_REQUIRED
        }
        if(!secondary) is_field_valid(other, true)
    }
    if (invalid) {
        showInvalid(div, message)
    } else {
        showValid(div, message)
    }
    return invalid === false
}

window.showInvalid = function(div, message) {
    div.addClass('has-error') // application form use bootstrap3, so need to handle old bootstrap class
    div.find('input, select').addClass('is-invalid')
    $('.error-msg', div).show()
    if (message) {
        $('.error-msg', div).text(message)
    }
}

window.showValid = function(div, message) {
    div.removeClass('has-error') // application form use bootstrap3, so need to handle old bootstrap class
    div.find('input, select').removeClass('is-invalid')
    $('.error-msg', div).hide()
    if (message) {
        $('.error-msg', div).text(message)
    }
}

window.is_password_valid = function(pass) {
    return (pass.length >= 10 && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W]).{10,}$/.test(pass))
}

window.is_email_valid = function(email) {
    return /^([\w\.%\+\-]+)@([\w\-]+\.)+([\w]{2,})$/i.test(email)
}

window.init_date_input = function(field) {
    $('#'+field+'_day, #'+field+'_month, #'+field+'_year').on('change', function() {
        var date = get_date_input(field)
        $('#'+field+'_input').val(date)
        if (window.liveValidation === true) is_field_valid(field)
    })
}

window.get_date_input = function(field) {
    function zeroPadding(val, len) {
        return ('0000' + val).slice(-len)
    }
    var day = $('#'+field+'_day')
    var month = $('#'+field+'_month')
    var year = $('#'+field+'_year')
    if (month.val() > 0 && year.val() > 0) {
        var str = zeroPadding(year.val(), 4) + '-' + zeroPadding(month.val(), 2)
        if (day.length > 0) {
            str += '-' + zeroPadding(day.val() > 0 ? day.val() : '1', 2)
        } else {
            str += '-01'
        }
        return str
    }
    return ''
}

window.is_date_valid = function(field, required, day_optional) {
    var year = $('#'+field+'_year').val()
    var month = $('#'+field+'_month').val()
    var day = $('#'+field+'_month').val()

    if (day_optional) {
        return (year && month) || (!required && !year && !month)
    } else {
        return (year && month && day) || (!required && !year && !month && !day)
    }
}

window.profile_base_url = function() {
    var act = '/account'
    var pos = location.href.indexOf(act)
    return (pos > 0) ? location.href.substring(0, pos + act.length) : act
}

window.detect_form_edit = function() {
    window.enabled_save_button = false
    $('#update-button, #create_profile').attr('disabled', true)
    $('.profile-form input, .profile-form select').on("change paste keyup", function() {
        enable_save_button()
    })
}

window.enable_save_button = function() {
    if (window.enabled_save_button === false) {
        window.enabled_save_button = true
        $('#update-button, #create_profile').attr('disabled', false)
        if (window.webkit !== undefined) {
            try {
                window.webkit.messageHandlers.callbackHandler.postMessage("form-updated");
            } catch(err) {
                console.log('The native context does not exist yet');
            }
        }
        else if (window.callbackHandler !== undefined) {
            try {
                window.callbackHandler.postMessage("form-updated");
            } catch(err) {}
        }
    }
}

// DO NOT rename or change this function, it is being used by the iOS mobile app
window.submit_os_account_form = function(user, pass) {
    $('#os_user').val(user)
    $('#os_pass').val(pass)
    submit_profile_form()
}

window.delete_image = function(field) {
    $('#' + field + '_field .input-image').css('display', 'none')
    $('#delete_image').val(field)
    enable_save_button()
}

window.showConfirm = function(title, message, yes, no, callback_or_url) {
    var modal = $('#confirmModal')
    modal.modal('show')
    modal.find('.modal-title').text(title)
    modal.find('.modal-body').html(message)
    modal.find('#confirm-yes').text(yes)
    modal.find('#confirm-no').text(no)
    $('#confirm-yes', modal).unbind('click').click(function() {
        $('#confirm-yes', modal).prop('disabled', true)
        $('#confirm-no', modal).prop('disabled', true)
        if (typeof callback_or_url == 'string') location.href = callback_or_url
        else callback_or_url()
    })
}

window.check_email_confirmation = function() {
    if (window.check_email_errors === undefined) {
        window.check_email_errors = 0
    }
    if (window.check_email_counter === undefined) {
        window.check_email_counter = 0
    }
    $.getJSON('/api/v1/account/email_confirmed', function(data) {
        if (data.confirmed === '1') {
            showValid($('#email_field'))
        } else {
            setTimeout(check_email_confirmation, (1000*10) + window.check_email_counter)
            window.check_email_counter += 1000
        }
    }).fail(function () {
        window.check_email_errors += 1
        if (window.check_email_errors < 11) {
            setTimeout(check_email_confirmation, 1000*60*window.check_email_errors)
        }
    });
}

window.confirm_sync = function(url, auto_sync) {
    let modal = $('#sync_modal')
    modal.modal('show')
    if (auto_sync === 'y') $('#modal_option_cb', modal).prop('checked', true)
    $('#confirm-yes', modal).unbind('click').click(function() {
        $('#confirm-yes', modal).prop('disabled', true)
        $('#confirm-no', modal).prop('disabled', true)
        let prefix = url.includes('?') ? '&' : '?';
        url += prefix + 'auto_sync=' + ($('#modal_option_cb', modal).prop('checked') ? 'y' : 'n');
        location.href = url;
    })
}

$(function() {
    $('#update-button').click(function () {
        submit_profile_form()
    })
    $('.password-toggle').click(function () {
        var src = $('img', $(this)).prop('src')
        var input = $('input', $(this).parent())
        var img = $('img', $(this))
        if (src.includes('eye-slash.png')) {
            img.prop('src', img.attr('src_hide'))
            input.prop('type', 'password')
        } else {
            img.prop('src', img.attr('src_show'))
            input.prop('type', 'text')
        }
        input.focus()
    })
})

window.init_bootstrap_table = function() {
    $("#bootstrap-table").bootstrapTable({
        sortable: true,
        mobileResponsive: true,
        editable: true,
        minWidth: 900,
        pagination: false,
        search: false,
    }).removeClass("table-bordered").on('click-row.bs.table', function (e, row, $element) {
        window.location = $element.data('href');
    });
}